import React from 'react';

const Blog = () => {
    return (
        <React.Fragment>
            <section className="pt-page pt-page-4" data-id="blog">
                <div className="section-title-block">
                    <h2 className="section-title">Blog</h2>
                    <h5 className="section-description">My Diary</h5>
                </div>
                <div className="blog-masonry">
                    {/* Blog Post */}
                    <div className="item">
                        <div className="blog-card">
                            <div className="media-block">
                                <a href="/blog/agile-vs-hybrid-approaches.html" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="post-image img-responsive"
                                        src="images/blog/agile-vs-hybrid.jpg"
                                        alt="agile-vs-hybrid-approaches"
                                    />
                                    <div className="mask" />
                                    <div className="post-date">
                                        <span className="day">23</span>
                                        <span className="month">Feb</span>
                                        <span className="year">2021</span>
                                    </div>
                                </a>
                            </div>
                            <div className="post-info">
                                <ul className="category">
                                    <li>
                                        <a href="/#">Software Engineering</a>
                                    </li>
                                </ul>
                                <a href="/blog/topological-data-analysis.html" target="_blank" rel="noopener noreferrer">
                                    <h4 className="blog-item-title">
                                        Agile VS Hybrid Software Development Approaches
                                    </h4>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* End of Blog Post */}
                    {/* Blog Post*/}
                    <div className="item">
                        <div className="blog-card">
                            <div className="media-block">
                                <a href="/blog/residual-analysis.html" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="post-image img-responsive"
                                        src="images/blog/residual-analysis.jpg"
                                        alt="residual-analysis"
                                    />
                                    <div className="mask" />
                                    <div className="post-date">
                                        <span className="day">20</span>
                                        <span className="month">January</span>
                                        <span className="year">2021</span>
                                    </div>
                                </a>
                            </div>
                            <div className="post-info">
                                <ul className="category">
                                    <li>
                                        <a href="/#">Data Science</a>
                                    </li>
                                </ul>
                                <a href="/blog/topological-data-analysis.html" target="_blank" rel="noopener noreferrer">
                                    <h4 className="blog-item-title">
                                        Resiudal Analysis for Linear Regression Models
                                    </h4>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* End of Blog Post*/}
                    {/* Blog Post*/}
                    <div className="item">
                        <div className="blog-card">
                            <div className="media-block">
                                <a href="/blog/blockchain.html" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="post-image img-responsive"
                                        src="images/blog/blockchain.jpg"
                                        alt="blockchain"
                                    />
                                    <div className="mask" />
                                    <div className="post-date">
                                        <span className="day">13</span>
                                        <span className="month">May</span>
                                        <span className="year">2020</span>
                                    </div>
                                </a>
                            </div>
                            <div className="post-info">
                                <ul className="category">
                                    <li>
                                        <a href="/#">Network</a>
                                    </li>
                                </ul>
                                <a href="/blog/blockchain.html" target="_blank" rel="noopener noreferrer">
                                    <h4 className="blog-item-title">
                                        Blockchain
                                    </h4>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* End of Blog Post*/}
                    {/* Blog Post*/}
                    <div className="item">
                        <div className="blog-card">
                            <div className="media-block">
                                <a href="/blog/topological-data-analysis.html" target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="post-image img-responsive"
                                        src="images/blog/tda.jpg"
                                        alt="topological-data-analysis"
                                    />
                                    <div className="mask" />
                                    <div className="post-date">
                                        <span className="day">5</span>
                                        <span className="month">May</span>
                                        <span className="year">2020</span>
                                    </div>
                                </a>
                            </div>
                            <div className="post-info">
                                <ul className="category">
                                    <li>
                                        <a href="/#">Data Science</a>
                                    </li>
                                </ul>
                                <a href="/blog/topological-data-analysis.html" target="_blank" rel="noopener noreferrer">
                                    <h4 className="blog-item-title">
                                        Topological Data Analysis
                                    </h4>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* End of Blog Post*/}
                </div>
            </section>
        </React.Fragment>
    );
};

export default Blog;